import { ProviderType } from 'src/modules/user/models/user';

export const getSessionTypeSlug = (providerType, isPsychiatryInitialEvaluation) => {
    if (providerType === ProviderType.PSYCHIATRIST) {
        return isPsychiatryInitialEvaluation
            ? 'psychiatry_initial_evaluation'
            : 'psychiatry_follow_up';
    } else if (providerType === ProviderType.COACH) {
        return 'coaching';
    } else {
        return 'therapy';
    }
};
